const topicItems = [
  { label: '明星塌房', hot: true },
  { label: '网红翻车', hot: true },
  { label: '综艺黑幕', hot: true },
  { label: '偷税漏税', hot: false },
  { label: '饭圈乱象', hot: true },
  { label: '剧组爆料', hot: false },
  { label: '代言暴雷', hot: false },
  { label: '假唱实锤', hot: false },
  { label: '潜规则', hot: true },
  { label: '合约纠纷', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-background-50 mb-10">
          # 热门话题
        </h2>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, idx) => (
            <span
              key={idx}
              className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-semibold cursor-pointer transition-all hover:scale-105 whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-500 text-background-50 text-base md:text-lg px-6 py-3'
                  : 'bg-transparent text-foreground-300 border border-foreground-600 hover:border-primary-400 hover:text-primary-400'
              }`}
            >
              {item.hot && (
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              )}
              {item.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}